import { __spreadArrays } from "tslib";

var Emitter =
/** @class */
function () {
  function Emitter() {
    this.callbacks = {};
  }

  Emitter.prototype.on = function (event, callback) {
    var _a;

    this.callbacks[event] = __spreadArrays((_a = this.callbacks[event]) !== null && _a !== void 0 ? _a : [], [callback]);
    return this;
  };

  Emitter.prototype.once = function (event, fn) {
    var _this = this;

    var on = function on() {
      var args = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }

      _this.off(event, on);

      fn.apply(_this, args);
    };

    this.on(event, on);
    return this;
  };

  Emitter.prototype.off = function (event, callback) {
    var _a;

    var fns = (_a = this.callbacks[event]) !== null && _a !== void 0 ? _a : [];
    var without = fns.filter(function (fn) {
      return fn !== callback;
    });
    this.callbacks[event] = without;
    return this;
  };

  Emitter.prototype.emit = function (event) {
    var _this = this;

    var _a;

    var args = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }

    var callbacks = (_a = this.callbacks[event]) !== null && _a !== void 0 ? _a : [];
    callbacks.forEach(function (callback) {
      callback.apply(_this, args);
    });
    return this;
  };

  return Emitter;
}();

export { Emitter };